<template>
  <Component
    :is="as"
    class="overflow-hidden rounded-lg bg-background p-4 shadow ring-1 ring-background-fg/5"
  >
    <slot />
  </Component>
</template>

<script setup lang="ts">
import type { Component } from "vue"

withDefaults(
  defineProps<{
    as?: Component | keyof HTMLElementTagNameMap
  }>(),
  { as: "div" }
)
</script>
